export default kendo.jQuery
